module.exports = __webpack_public_path__ + "static/media/typography.5dd9d7df.svg";